import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

/** 완료 화면(CompleteStep) 래퍼 — #root 바로 아래라 직접 full-height flex 컨텍스트를 만들어
 *  CompleteStep 내부 BottomBar(확인했어요)가 viewport 하단에 고정되게 한다. */
export const SuccessWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
`

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: 24px calc(20px + var(--safe-bottom, 0px));
  gap: 16px;
  text-align: center;
  background-color: ${COLORS.bgWhite};
`

export const StateTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: ${COLORS.textPrimary};
  margin: 0;
`

export const StateDescription = styled.p`
  font-size: 14px;
  color: ${COLORS.textSecondary};
  margin: 0;
  line-height: 1.5;
`
